<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
      <hr>
      
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["userNo"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.userNo">
        </div>
    </div>  
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["userName"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.userName">
        </div>
    </div>  
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["pwd"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.pwd">
        </div>
    </div>  
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["roleName"]}}</span>
              <input v-if='action=="View"' type="text" v-bind:readonly='action=="View"' v-model="data.roleName" class="form-control">
              <select v-else v-model="data.roleNo" @change="roleChange" class="form-control">
                <option v-for='item in roleList' :value='item.roleNo'>{{item.roleName}}</option>
              </select>
        </div>
    </div> 
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["status"]}}</span>
          <input type="checkbox" class="mui-switch"  v-bind:disabled='action=="View"' v-model="data.status">
        </div>
    </div>
    <div class="row" style="display:none">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["wechatId"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.wechatId">
        </div>
    </div>
    <div class="row">
      <div class="input-group col-md-6">
          <span class="input-group-addon" >{{rs["companyName"]}}</span>
          <div class="form-control">
            <label v-for='item in comList' style="margin-left: 30px;"><input type="checkbox" :value="item.companyNo" v-model="ucList"/>{{item.companyName}}</label>
          </div>
        
      </div>
    </div>
  </div>
</template>

<<script>
import mixin from "../../mixin/detailMixin.js";
export default {
  //created(){
  //  alert(this.$UrlSq())
  //},
  props:["roleList","comList", "ucList"],
  
  methods: {
    roleChange(){
     this.data.roleName=this.roleList.find(item=>item.roleNo===this.data.roleNo).roleName
    },
    save:function(){
       if (!this.checkNull(this.data.userNo, "nullNo")) return
       if (!this.checkNull(this.data.userName, "nullName")) return
       if (!this.checkNull(this.data.pwd, "nullPwd")) return

       const userCmp = []

       this.ucList.forEach(d=>{
         let uc = this.comList.filter(it=>{return it.companyNo==d})
         if (uc && uc.length>0){
            uc=uc[0]
            userCmp.push({"userNo":this.data.userNo, "userName": this.data.userName, "companyNo":d, "companyName":uc.companyName})
          }
       })

       const sdata={"user": this.data, "cmp": userCmp}

      if (this.action == "Add" || this.action == "Copy") {
        this.$save(this.url + "AddX", sdata, this.saveResult);
        
      } else if (this.action == "Edit") {
        this.$save(this.url + "EditX", sdata, this.saveResult);
      }
    }
  },
  mixins:[mixin]
}
</script>

